import { useState, useEffect } from 'react';
import { Input } from '../../../ui/input';
import { Label } from '@radix-ui/react-label';
import Parents from './ParentsBranch';
import PartnerKids, { ShowPartnerKids } from './PartnerKids';
import modalimg from '../../img/modal.png';

const Niveau3AncInd = () => {
  const [showParents, setShowParents] = useState(false);
  const [showFamilyTree, setShowFamilyTree] = useState(true);
  const [showData, setShowData] = useState(false);
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [birthPlace, setBirthPlace] = useState(null);
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showModal, setShowModal] = useState(false);
  const isFormComplete = lastName && firstName && email && phoneNumber;
  const [statusStep, setStatusStep] = useState('confirm');
  const [disabled, setDisabled] = useState(true);
  const [partnerKidsVisible, setPartnerKIds] = useState(false);
  const [showIntroModal, setShowIntroModal] = useState(false);

  // États d'erreur
  const [emailError, setEmailError] = useState('');
  const [phoneError, setPhoneError] = useState('');

  useEffect(() => {
    localStorage.clear();
    setShowIntroModal(true);
  }, []);

  const handleChangeToPartnerKids = () => {
    setPartnerKIds(true);
    setDisabled(false);
  };

  const handleChangeFirstName = (e) => {
    setFirstName(e.target.value);
    localStorage.setItem("firstname", e.target.value);
  };

  const handleChangeLastName = (e) => {
    const upperCaseValue = e.target.value.toUpperCase();
    setLastName(upperCaseValue);
    localStorage.setItem("lastname", upperCaseValue);
  };

  const handleChangeEmail = (e) => {
    const value = e.target.value;
    setEmail(value);
    localStorage.setItem("email", value);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      setEmailError('Email invalide');
    } else {
      setEmailError('');
    }
  };

  const handleChangePhoneNumber = (e) => {
    const value = e.target.value;
    setPhoneNumber(value);
    localStorage.setItem("phonenumber", value);

    const phoneRegex = /^\+?\d{10,15}$/;
    if (!phoneRegex.test(value)) {
      setPhoneError('Numéro invalide (min. 10 chiffres, chiffres uniquement)');
    } else {
      setPhoneError('');
    }
  };

  // Validation finale pour désactiver le bouton si erreurs
  const isFormValid = isFormComplete && !emailError && !phoneError;

  const exportAndReset = async () => {
    setStatusStep('loading');

    // Reconstituer le tableau des enfants à partir du localStorage
    const children = [];
    let index = 0;
    while (localStorage.getItem(`firstnamechild${index}`)) {
      children.push({
        firstname: localStorage.getItem(`firstnamechild${index}`) || "",
        lastname: localStorage.getItem(`lastnamechild${index}`) || "",
        birthdate: localStorage.getItem(`birthbornchild${index}`) || "", // Assurez-vous d'être cohérent dans les noms
        birthplace: localStorage.getItem(`birthplacechild${index}`) || ""
      });
      index++;
    }

    const data = {
      firstname: localStorage.getItem("firstname"),
      lastname: localStorage.getItem("lastname"),
      birthborn: localStorage.getItem("birthborn"),
      birthplace: localStorage.getItem("birthplace"),
      email: localStorage.getItem("email"),
      phonenumber: localStorage.getItem("phonenumber"),
      postaladdress: localStorage.getItem("postaladdress"),

      firstnamemother: localStorage.getItem("firstnamemother"),
      lastnamemother: localStorage.getItem("lastnamemother"),
      birthbornmother: localStorage.getItem("birthbornmother"),
      birthplacemother: localStorage.getItem("birthplacemother"),

      firstnamefather: localStorage.getItem("firstnamefather"),
      lastnamefather: localStorage.getItem("lastnamefather"),
      birthbornfather: localStorage.getItem("birthbornfather"),
      birthplacefather: localStorage.getItem("birthplacefather"),

      // Informations sur les grands-parents
      firstnamegp1: localStorage.getItem("firstnamegp1"),
      lastnamegp1: localStorage.getItem("lastnamegp1"),
      birthborngp1: localStorage.getItem("birthborngp1"),
      birthplacegp1: localStorage.getItem("birthplacegp1"),

      firstnamegp3: localStorage.getItem("firstnamegp3"),
      lastnamegp3: localStorage.getItem("lastnamegp3"),
      birthborngp3: localStorage.getItem("birthborngp3"),
      birthplacegp3: localStorage.getItem("birthplacegp3"),

      // Informations sur les grands-mères
      firstnamegm2: localStorage.getItem("firstnamegm2"),
      lastnamegm2: localStorage.getItem("lastnamegm2"),
      birthborngm2: localStorage.getItem("birthborngm2"),
      birthplacegm2: localStorage.getItem("birthplacegm2"),

      firstnamegm4: localStorage.getItem("firstnamegm4"),
      lastnamegm4: localStorage.getItem("lastnamegm4"),
      birthborngm4: localStorage.getItem("birthborngm4"),
      birthplacegm4: localStorage.getItem("birthplacegm4"),

      // Informations sur les arrière-grands-pères
      firstnameggp1: localStorage.getItem("firstnameggp1"),
      lastnameggp1: localStorage.getItem("lastnameggp1"),
      birthbornggp1: localStorage.getItem("birthbornggp1"),
      birthplaceggp1: localStorage.getItem("birthplaceggp1"),

      firstnameggp3: localStorage.getItem("firstnameggp3"),
      lastnameggp3: localStorage.getItem("lastnameggp3"),
      birthbornggp3: localStorage.getItem("birthbornggp3"),
      birthplaceggp3: localStorage.getItem("birthplaceggp3"),

      firstnameggp5: localStorage.getItem("firstnameggp5"),
      lastnameggp5: localStorage.getItem("lastnameggp5"),
      birthbornggp5: localStorage.getItem("birthbornggp5"),
      birthplaceggp5: localStorage.getItem("birthplaceggp5"),

      firstnameggp7: localStorage.getItem("firstnameggp7"),
      lastnameggp7: localStorage.getItem("lastnameggp7"),
      birthbornggp7: localStorage.getItem("birthbornggp7"),
      birthplaceggp7: localStorage.getItem("birthplaceggp7"),

      // Informations sur les arrière-grands-mères
      firstnameggm2: localStorage.getItem("firstnameggm2"),
      lastnameggm2: localStorage.getItem("lastnameggm2"),
      birthbornggm2: localStorage.getItem("birthbornggm2"),
      birthplaceggm2: localStorage.getItem("birthplaceggm2"),

      firstnameggm4: localStorage.getItem("firstnameggm4"),
      lastnameggm4: localStorage.getItem("lastnameggm4"),
      birthbornggm4: localStorage.getItem("birthbornggm4"),
      birthplaceggm4: localStorage.getItem("birthplaceggm4"),

      firstnameggm6: localStorage.getItem("firstnameggm6"),
      lastnameggm6: localStorage.getItem("lastnameggm6"),
      birthbornggm6: localStorage.getItem("birthbornggm6"),
      birthplaceggm6: localStorage.getItem("birthplaceggm6"),

      firstnameggm8: localStorage.getItem("firstnameggm8"),
      lastnameggm8: localStorage.getItem("lastnameggm8"),
      birthbornggm8: localStorage.getItem("birthbornggm8"),
      birthplaceggm8: localStorage.getItem("birthplaceggm8"),

      // Données du partenaire
      firstnamepartner: localStorage.getItem("firstnamepartner"),
      lastnamepartner: localStorage.getItem("lastnamepartner"),
      birthbornpartner: localStorage.getItem("birthbornpartner"), // Assure-toi d'utiliser le bon nom
      birthplacepartner: localStorage.getItem("birthplacepartner"),

      // Tableau dynamique des enfants
      children: children
    };

    try {
      const response = await fetch("https://script.google.com/macros/s/AKfycbypXdn_ZHtZSmD7UXam1kD1EMu4uWiSzgdOq027i6r-VvfKyP7vXWmk6FsRdgPVn8xyMQ/exec", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        mode: 'no-cors', // Important pour éviter les erreurs de CORS
      });
      response.text();

      setStatusStep('success');

      setTimeout(() => {
        // Réinitialisation des états et du localStorage
        localStorage.clear();
        setLastName('');
        setFirstName('');
        setBirthPlace('');
        setEmail('');
        setPhoneNumber('');
        setShowParents(false);
        setShowFamilyTree(true);
        setShowData(false);
        setShowModal(false);
        setStatusStep('confirm');
        setPartnerKIds(false);
        setDisabled(true);
      }, 2000);
    } catch (error) {
      setStatusStep('error');
    }
  };

  return (
    <>
      {showData && (
        <div className="w-full p-4 mb-4 text-center font-semibold bg-blue-400 text-white-800">
            Remplissez toutes les parties de ce formulaire pour valider votre arbre et pour envoyer votre arbre cliquez sur le bouton "Envoyer votre arbre" en bas de la page.
        </div>
      )}
      {showParents && (
        <div>
          <Parents setShowData={setShowData} setShowFamilyTree={setShowFamilyTree} setShowParents={setShowParents} />
          <ShowPartnerKids />
        </div>
      )}

      {showFamilyTree && (
        <form className="mx-auto max-w-lg">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-800 dark:text-white">
            Créez votre propre arbre généalogique
          </h1>
          <div className='p-10 bg-white dark:bg-black flex items-start justify-center'>
            <div className="w-full border border-gray-700 rounded-lg p-6 shadow-md dark:bg-neutral-900 bg-gray-100">
              <div className="mb-4">
                <Label className='text-black dark:text-white'>Nom <mark className='text-red-500 bg-transparent italic text-base'>(obligatoire)</mark></Label>
                <Input id="lastname" value={lastName} onChange={handleChangeLastName} className="w-full max-w-sm" placeholder="Entrez votre nom" required />
              </div>
              <div className="mb-4">
                <Label className='text-black dark:text-white'>Prénom <mark className='text-red-500 bg-transparent italic text-base'>(obligatoire)</mark></Label>
                <Input id="firstname" value={firstName} onChange={handleChangeFirstName} className="w-full max-w-sm" placeholder="Entrez votre prénom" required/>
              </div>
              <div className="mb-4">
                <Label className='text-black dark:text-white'>Email <mark className='text-red-500 bg-transparent italic text-base'>(obligatoire)</mark></Label>
                <Input
                  type="email"
                  value={email}
                  onChange={handleChangeEmail}
                  className={`w-full max-w-sm ${emailError ? 'border-red-600' : ''}`}
                  id="email"
                  placeholder="Entrez votre email"
                />
                {emailError && <p className="text-red-600 text-sm mt-4 font-bold">{emailError}</p>}
              </div>
              <div className="mb-4">
                <Label className='text-black dark:text-white'>Téléphone <mark className='text-red-500 bg-transparent italic text-base'>(obligatoire)</mark></Label>
                <Input
                  type="tel"
                  id="phoneNumber"
                  value={phoneNumber}
                  onChange={handleChangePhoneNumber}
                  className={`w-full max-w-sm ${phoneError ? 'border-red-600' : ''}`}
                  placeholder="Entrez votre téléphone"
                />
                {phoneError && <p className="text-red-600 text-sm mt-4 font-bold">{phoneError}</p>}
              </div>
              {disabled && (
                <div className='mb-4'>
                  <p className='dark:text-white text-black'>Pour ajouter vos descendants directs (enfants) <br></br> ou votre conjoint(e), <br></br>cliquez ici :</p>
                  <button
                    type='button'
                    onClick={handleChangeToPartnerKids}
                    className="py-3 px-4 bg-blue-100 text-blue-800 rounded-lg hover:bg-blue-200 disabled:opacity-50"
                  >
                    Entrez
                  </button>
                  <button
                    disabled={!isFormValid}
                    onClick={() => {
                      setShowParents(true);
                      setShowFamilyTree(false);
                      setShowData(true);
                      setTimeout(() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }, 100);
                    }}
                    type="button"
                    className="py-3 px-4 bg-green-100 text-green-800 rounded-lg hover:bg-green-200 disabled:opacity-50"
                  >
                    Suivant
                  </button>
                </div>
              )}
              {partnerKidsVisible && (
                <PartnerKids forShowData={setShowData} isFormComplete={isFormValid} setFamilyTree={setShowFamilyTree} setShowParents={setShowParents} />
              )}
            </div>
          </div>
        </form>
      )}

      {showData && (
        <div className="mx-auto max-w-lg">
          <div className="p-10 bg-white dark:bg-black flex items-start justify-center">
            <div className="w-full border border-gray-700 rounded-lg p-6 shadow-md dark:bg-neutral-900 bg-gray-100">
              <p className="text-2xl font-bold text-black dark:text-white">{lastName} {firstName}</p>
              <p className="text-2xl font-bold text-black dark:text-white">{birthPlace}</p>
            </div>
          </div>
            <div className="flex items-center justify-center mt-4">
              <button
                onClick={() => setShowModal(true)}
                type="button"
                className="py-3 px-4 text-2xl bg-green-100 text-green-800 rounded-lg hover:bg-green-200 mb-10"
              >
                Envoyer votre arbre
              </button>
            </div>
        </div>
      )}

      {/* Modale de confirmation */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-opacity-50 bg-gray-700">
          <div className="bg-white dark:bg-neutral-900 p-6 rounded-lg shadow-lg w-96 text-center">
            {statusStep === 'confirm' && (
              <>
                <h2 className="text-xl font-semibold mb-4 dark:text-white text-black">Confirmer l'envoi</h2>
                <p className='dark:text-white text-black mb-6'>Êtes-vous sûr de vouloir envoyer vos données ?</p>
                <div className="flex justify-between">
                  <button
                    onClick={() => setShowModal(false)}
                    className="py-2 px-4 bg-gray-300 rounded-lg hover:bg-gray-400"
                  >
                    Annuler
                  </button>
                  <button
                    onClick={exportAndReset}
                    className="py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                  >
                    Confirmer
                  </button>
                </div>
              </>
            )}

            {statusStep === 'loading' && (
              <div className="flex flex-col items-center">
                <div className="loader mb-4 border-4 border-blue-500 border-t-transparent rounded-full w-12 h-12 animate-spin" />
                <p className='dark:text-white text-black'>Envoi en cours... <br></br> Veuillez patientez s'il vous plait</p>
              </div>
            )}

            {statusStep === 'success' && (
              <div className="flex flex-col items-center text-green-600">
                <svg className="w-12 h-12 mb-2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                <p>Envoi réussi !</p>
              </div>
            )}

            {statusStep === 'error' && (
              <div className="flex flex-col items-center text-red-600">
                <svg className="w-12 h-12 mb-2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
                <p>Une erreur est survenue !</p>
              </div>
            )}
          </div>
        </div>
      )}
      {showIntroModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white dark:bg-neutral-900 rounded-xl shadow-2xl max-w-4xl w-full m-3 max-h-[calc(100vh-56px)] flex flex-col">
            {/* Header */}
            <div className="flex justify-between items-center py-3 px-4 border-b border-gray-200 dark:border-neutral-800">
              <h3 className="font-bold text-gray-800 dark:text-neutral-200">
                Bienvenue !
              </h3>
              <button
                type="button"
                className="size-8 inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-hidden focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-700 dark:hover:bg-neutral-600 dark:text-neutral-400 dark:focus:bg-neutral-600"
                aria-label="Close"
                onClick={() => setShowIntroModal(false)}
              >
                <span className="sr-only">Fermer</span>
                <svg
                  className="shrink-0 size-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>
              </button>
            </div>
      
            {/* Content */}
            <div className="p-4 overflow-y-auto space-y-4 text-gray-700 dark:text-neutral-300">
              <img
                src={modalimg}
                alt="Illustration"
                className="rounded-lg mx-auto"
              />

              <p><strong>Pourquoi remplir ce formulaire ?</strong></p>
              <p>
                Remplir ce formulaire vous permettra de retrouver la trace de votre ancêtre indien, 
                une étape essentielle si vous souhaitez entamer des démarches officielles pour renouer avec vos origines.
              </p>
              <p>
                Cette recherche peut vous ouvrir l'accès à la carte OCI (Overseas Citizen of India), 
                un statut reconnu par le gouvernement indien.
              </p>
      
              <p>🪪 <strong>Quels sont les avantages de la carte OCI ?</strong><br />
              Elle vous permet notamment :</p>
              <ul className="list-disc list-inside space-y-1">
                <li>D'entrer en Inde sans visa, pour une durée illimitée</li>
                <li>De séjourner librement en Inde, sans renouveler de visa</li>
                <li>D'acheter un bien immobilier (hors terres agricoles)</li>
                <li>D'étudier en Inde dans certaines universités ou établissements publics</li>
                <li>De maintenir un lien légal et symbolique fort avec vos racines</li>
              </ul>
      
              <p>👣 <strong>Faites simplement ce que vous pouvez.</strong><br />
              Même si vous n'avez pas toutes les informations, ce que vous savez suffit souvent pour commencer les recherches.</p>
      
              <p>🧾 <strong>Et ensuite ?</strong><br />
              Une fois le formulaire complété, nous vous recontacterons pour vous transmettre le nom de votre ancêtre indien retrouvé, et vous proposer de poursuivre si vous souhaitez faire votre carte OCI.</p>
            </div>
      
            {/* Footer */}
            <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t border-gray-200 dark:border-neutral-800">
              <button
                type="button"
                className="py-2 px-3 inline-flex items-center gap-x-2 text-base font-bold rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
                onClick={() => setShowIntroModal(false)}
              >
                Commencer le formulaire
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Niveau3AncInd;
